// Generated by ReScript, PLEASE EDIT WITH CARE


var fast = 80;

var regular = 150;

var slow = 300;

var extraSlow = 2500;

export {
  fast ,
  regular ,
  slow ,
  extraSlow ,
}
/* No side effect */
